import { Box, Card, CardHeader, CardBody, Heading, Text, Button } from '@chakra-ui/react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { EmailSoaForm } from '@/components/forms/EmailSoaForm'

export default function EmailSoaToClientPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ shippingLineId: string; soaId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const soaIdFromParams = params.soaId ? parseInt(params.soaId, 10) : undefined

  // Get data from navigation state or route params
  const navigationState = location.state as
    | {
        shippingLineName?: string
        shippingLineId?: string
        soaId?: number
      }
    | null
  const shippingLineName = navigationState?.shippingLineName || ''
  const finalShippingLineId =
    navigationState?.shippingLineId || paramsShippingLineId
  const finalSoaId = navigationState?.soaId ?? soaIdFromParams
  const validSoaId =
    typeof finalSoaId === 'number' && Number.isFinite(finalSoaId) ? finalSoaId : null

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Email Statement of Account to Client
            </Heading>
          </CardHeader>
          <CardBody>
            {validSoaId == null ? (
              <Box>
                <Text color={colors.textSecondary} mb={4}>
                  Invalid SOA. Cannot send email.
                </Text>
                <Button size="sm" variant="outline" onClick={handleCancel}>
                  Cancel
                </Button>
              </Box>
            ) : (
              <EmailSoaForm
                shippingLineName={shippingLineName}
                soaId={validSoaId}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            )}
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

